import { TitleBlockWrapper } from '@anm/components/TitleBlock';
import Dialog from '@anm/components/modals/Dialog';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

import TitleBlock from '../../TitleBlock';

export const Title = styled(TitleBlock)`
  && { max-width: unset; }
`

const mobileStyles = media.phone`
  padding: 34px 32px 30px;
`;

const ShareDialogWrapper = styled(Dialog)`
  padding: 25px 40px 40px;
  text-align: center;

  ${TitleBlockWrapper} {
    margin-bottom: 24px;
  }
  ${mobileStyles};
`;

export default ShareDialogWrapper;
